import React, { FC } from 'react'

export const MessageActiveSvg: FC<{ size?: number; id?: number | string }> = ({
  size = 40,
  id = 0,
}) => (
  <svg width={size} height={size} viewBox="0 0 40 40">
    <defs>
      <linearGradient
        id={`2dvaczv0ba_${id}`}
        x1="26.563%"
        x2="73.786%"
        y1="-27.379%"
        y2="113.7%"
      >
        <stop offset="0%" stopColor="#A9C0FF" />
        <stop offset="100%" stopColor="#5473E8" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g fill={`url(#2dvaczv0ba_${id})`} transform="translate(-713 -1128)">
        <g>
          <path
            d="M39 19.916C39 13.75 34.781 4 20.5 4 6.219 4 2 13.95 2 19.916c0 5.966 5.341 15.437 17.389 15.437 3.966 0 3.68-.111 6.82-.426l7.624 2.954c.829.336 1.772-.065 2.107-.896.09-.222.13-.461.115-.7-1.61-3.938-1.65-6.805-.115-8.6 1.88-2.2 3.06-4.812 3.06-7.77z"
            transform="translate(713 1128)"
          />
        </g>
      </g>
    </g>
  </svg>
)
